// import { Box } from "@mui/material";
// import React, { useEffect, useState } from "react";

// function TextAnimation() {
//   const text = [
//     { id: 1, label: "automobile" },
//     { id: 2, label: "refrigerator" },
//     { id: 3, label: "air-conditioner" },
//     { id: 4, label: "washing machine" },
//     { id: 5, label: "appliances.." },
//   ];

//   const [currentIndex, setCurrentIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % text.length);
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [text.length]);

//   return (
//     <Box
//       sx={{
//         height: { xs: "40px", sm: "64px", md: "88px" },
//         overflow: "hidden",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: { xs: "center", sm: "start", md: "start" },
//       }}
//     >
//       {text.map((item) => (
//         <span
//           key={item.id}
//           style={{
//             height: "88px",
//             fontSize: { xs: "40px", sm: "48px", md: "64px" },
//             verticalAlign: "middle",
//             transform: `translateY(-${currentIndex * 88}px)`,
//             transition:
//               currentIndex === 0 ? "transform 0.2s ease-out" : "transform 1.2s ease-in-out",
//             fontWeight: { xs: 600, sm: 600, md: 700 },
//             lineHeight: 1.4,
//             color: "#3698BF",
//             padding: "0 8px",
//           }}
//         >
//           {item.label}
//         </span>
//       ))}
//     </Box>
//   );
// }

// export default TextAnimation;

import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";

function TextAnimation() {
  const text = [
    { id: 1, label: "automobile." },
    { id: 2, label: "refrigerator." },
    { id: 3, label: "air-conditioner." },
    { id: 4, label: "washing machine." },
    { id: 5, label: "appliances..." },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % text.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [text.length]);

  return (
    <Box
      sx={{
        height: { xs: "40px", sm: "64px", md: "95px" },
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "center", sm: "start", md: "start" },
        animation: "textAnimation 1.6s linear",
        "@keyframes textAnimation": {
          "0%": {
            transform: "translateY(0)",
          },
          "100%": {
            transform: "translateY(0)",
          },
        },
      }}
    >
      {text.map((item) => (
        <span
          key={item.id}
          style={{
            // height: "90px",
            fontSize: { xs: "40px", sm: "48px", md: "64px" },
            verticalAlign: "middle",
            transform: `translateY(-${currentIndex * 90}px)`,
            transition:
              currentIndex === 0 ? "transform 0.3s ease-out" : "transform 1.5s ease-in-out",
            fontWeight: { xs: 600, sm: 600, md: 700 },
            lineHeight: 1.4,
            padding: "0px",
          }}
        >
          {item.label}
        </span>
      ))}
    </Box>
  );
}

export default TextAnimation;
